import styled from '@emotion/styled'
import { FlexBox } from 'app/components/Layout/FlexBox'
import { styles } from 'app/theme'
import { useVocabularyData } from 'app/utils/vocabulary'
import { compact, uniqBy } from 'lodash'
import React, { memo } from 'react'

import { FooterMenuItem, Props as FooterMenuItemProps } from './FooterMenuItem'

export interface Props {
  footerMenu?: { [key: string]: FooterMenuItemProps[] }[]
  languageCode: string
}

export const Menu = memo(function Menu({ languageCode, footerMenu }: Props) {
  return (
    <Container row space="between" wrap>
      <Box>
        <Label>{useVocabularyData('stay', languageCode)}</Label>

        <Nav>
          {footerMenu ? (
            <>
              {uniqBy(footerMenu, 'title').map((item: any, index) => (
                <FooterMenuItem key={index} {...item} />
              ))}
            </>
          ) : null}
        </Nav>
      </Box>
    </Container>
  )
})

const Container = styled(FlexBox)`
  @media (max-width: 1199px) {
    width: 100%;
    margin-bottom: 3rem;
  }
`

const Box = styled.div`
  ${styles.description.dark}

  margin-left: 9.6875rem;

  &:first-of-type {
    margin-left: 0;
  }

  @media (max-width: 1199px) {
    width: 4.125rem;
    margin-left: 0;
  }
`

const Label = styled.div`
  ${styles.title.small}

  margin-bottom: 1.25rem;

  @media (max-width: 1199px) {
    margin-bottom: 0.75rem;
  }
`

const Nav = styled.ul`
  li {
    margin-bottom: 0.375rem;
  }
`
